import { browserTimeZone } from '../lib/dates';
import { redirectTo } from '../lib/redirect';
import { authClient } from './client';

export type AuthResult = { ok: true } | { ok: false; message: string };

interface AuthError {
  message?: string | undefined;
  statusText?: string | undefined;
}

export const NETWORK_ERROR = 'Network error. Check your connection and try again.';

export function toAuthResult(error: AuthError | null): AuthResult {
  if (error === null) return { ok: true };
  // better-fetch's catchAllError reports a rejected fetch as a 500 with this statusText.
  if (error.statusText === 'Fetch Error') return { ok: false, message: NETWORK_ERROR };
  return { ok: false, message: error.message ?? 'Sign-in failed. Try again.' };
}

export async function signInWithEmail(email: string, password: string): Promise<AuthResult> {
  const { error } = await authClient.signIn.email({ email, password });
  return toAuthResult(error);
}

export async function signUpWithEmail(input: { name: string; email: string; password: string }): Promise<AuthResult> {
  const { error } = await authClient.signUp.email({ ...input, timezone: browserTimeZone() });
  return toAuthResult(error);
}

export async function signInWithStrava(origin: string = window.location.origin): Promise<AuthResult> {
  const { data, error } = await authClient.signIn.social({
    provider: 'strava',
    callbackURL: `${origin}/`,
    newUserCallbackURL: `${origin}/onboarding/ftp`,
    errorCallbackURL: `${origin}/sign-in?error=strava`,
    disableRedirect: true,
  });
  if (error !== null) return toAuthResult(error);
  if (data.url !== undefined) redirectTo(data.url);
  return { ok: true };
}
